import MoreWaysToPlayButtons from "./MoreWaysToPlayButtons";

import styles from "./MoreWaysToPlayModal.module.scss";

import type { Dictionary } from "~/utils/dictionaries";

export default function MoreWaysToPlayModal({
	copy,
	links,
	isOpen,
	setIsOpen,
}: {
	copy: Dictionary;
	links: { href: string; title: string }[];
	isOpen: boolean;
	setIsOpen: (arg: boolean) => void;
}): React.ReactNode {
	function handleClick(): void {
		setIsOpen(false);
	}

	return (
		<div
			id="modal"
			className={`modal`}
			style={{ display: isOpen ? "flex" : "none" }}
			onClick={() => handleClick()}
			onKeyDown={() => handleClick()}
			role="presentation"
		>
			<div className={`modal-background ${styles.modalBg}`} />
			<div className={`modal-card ${styles.modalCard}`}>
				<div
					className={`modal-content m-0 ${styles.modalContent}`}
					onClick={(e) => {
						e.stopPropagation();
					}}
				>
					<h1 className="article-title-plain is-size-3 has-text-white mb-3">{copy.morewaystoplay.title}</h1>
					<MoreWaysToPlayButtons links={links} />
				</div>
			</div>
			<button
				onClick={() => handleClick()}
				onKeyDown={() => handleClick()}
				className={`modal-close ${styles.modalClose}`}
				aria-label="close"
			></button>
		</div>
	);
}
